import React from 'react';
import classnames from 'classnames';
import { isEmpty, get, isEqual, map } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { radioBox as RadioBox } from 'ui/views/generic/radioBox';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { radioListField as RadioListField } from 'ui/views/generic/radioListField';
 *
 * // render
 * <RadioListField propName='propValue'/>
 */
export const radioListField = ( props ) => {

    // get error message (ref)
    const errorMessage = get( props.error, 'message', null );
    const hasError = ! isEmpty( errorMessage );

    // dynamic class name
    const widgetClassName = classnames( 'ui-radio-list-field', props.className, {
        'ui-radio-list-field--error': hasError,
    } );

    return (
        <div className={ widgetClassName }>

            {/* field view */}
            <div className='ui-radio-list-field__control'>

                {/* label */}
                {
                    ! isEmpty( props.label ) ? (
                        <div className='ui-radio-list-field__control__label'>
                            
                            {/* label text */}
                            <div className='ui-radio-list-field__control__label__text'>{ getLabel( props.label ) }</div>

                            {/* required asterisk */}
                            {
                                props.required ? (
                                    <div className='ui-radio-list-field__control__label__asterisk'>*</div>
                                ) : null
                            }
                        </div>
                    ) : null
                }

                {/* choices (options) */}
                <div className='ui-radio-list-field__control__choices'>
                    {
                        map( props.options, option => {
                            return (
                                <div
                                    key={ option.name }
                                    className='ui-radio-list-field__control__choices__item'
                                    onClick={ () => props.onChange( {
                                        name: props.name,
                                        value: option.value
                                    } ) }
                                >
                                    <div className='ui-radio-list-field__control__choices__item__radio'>
                                        <RadioBox
                                            name={ option.name }
                                            value={ option.value }
                                            selected={ props.value === option.value }
                                        />
                                    </div>
                                    <div className='ui-radio-list-field__control__choices__item__label'>
                                        { getLabel( option.title ) }
                                    </div>
                                </div>
                            );
                        } )
                    }
                </div>
            </div>

            {/* error message */}
            {
                hasError && ! isEqual( props.mode, 'readonly' ) ? (
                    <div className='ui-radio-list-field__error'>
                        <div className='ui-radio-list-field__error__message'>
                            { getLabel( errorMessage ) }
                        </div>
                    </div>
                ) : null
            }
        </div>
    );
};

// set display name
radioListField.displayName = 'radioListField';

// set default props
radioListField.defaultProps = {};

// prop types
radioListField.propTypes = {};
